import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"margin-top":"0!important"}},[_c(VBtn,{staticClass:"secondary mt-4 mb-4",attrs:{"elevation":1,"text":""},on:{"click":_vm.addItem}},[_vm._v(" "+_vm._s(_vm.$t("AddClass"))+" ")]),_vm._l((_vm.classSubmissions),function(submission,idx){return _c('class-submission-component',{key:idx,attrs:{"number":idx + 1,"value":submission},on:{"remove-class-submission":_vm.removeItem}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }